import React, { Component } from "react";
import { withRouter, Redirect } from "react-router";

import {
  Button,
  Card,
  CardGroup,
  Col,
  Form,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Row,
  CardBody,
} from "reactstrap";

import "./Login.scss";

import ErrorToast from "../../utils/toasts/ErrorToast";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Spinner from "../../utils/Spinner";
import I18n from "../../utils/I18n";
import UserService from "../../../services/UserService";
import CookieService from "../../../services/CookieService";
import Errors from "../../constants/Errors";
import { colors } from "../../Theme/Colors/ColorList";

const Constants = require("../../constants/Constants");

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      message: false,
      error: false,
      email: "",
      password: "",
    };
  }

  componentDidMount() {
    this.setState({
      loading: false,
      message: false,
      error: false,
      email: "",
      password: "",
    });
  }

  validateFields() {
    const emailRegex = /[\w-\.]+@([\w-]+\.)+[\w-]{2,4}/;

    if (this.state.email === "") {
      this.setState({
        error: Errors.EDIT.MISSING.EMAIL,
      });
      return false;
    } else if (!emailRegex.test(this.state.email)) {
      this.setState({
        error: Errors.EDIT.INVALID.EMAIL,
      });
      return false;
    }

    return true;
  }

  // log in with the server and verify that the user is an admin
  onLogin = (event) => {
    event.preventDefault();
    let self = this;

    if (!self.validateFields()) return;

    self.setState({ loading: true });
    UserService.login(
      this.state.email,
      this.state.password,
      async function (result) {
        const user = result.user;
        if (user.role === "Admin") {
          if (!user.active) {
            self.setState({
              error: Errors.LOGIN.NO_ACTIVE,
              message: false,
              loading: false,
            });
          } else {
            CookieService.set("token", result.session.token);
          }
        } else {
          self.setState({
            error: Errors.LOGIN.NO_ADMIN,
            message: false,
            loading: false,
          });
        }
      },
      function (err) {
        console.log(err);
        self.setState({ error: err, message: false, loading: false });
      }
    );
  };

  // sends an email with the recovery code
  toSendRecoveryEmailPage = () => {
    //this.props.history.push(Constants.ROUTES.FORGOT);
  };

  // mail and password set
  isSendEnabled = () => {
    return this.state.email && this.state.password;
  };

  render() {
    if (CookieService.get("token")) {
      return <Redirect to={Constants.ROUTES.DASHBOARD} />;
    }

    const loading = this.state.loading;
    const disabled = !this.isSendEnabled();
    return (
      <div
        className={
          loading
            ? "app flex-row align-items-center Loading"
            : "app flex-row align-items-center"
        }
      >
        {/* {Spinner.render(loading)} */}
        <div className="col-md-8 col-sm-4 loginImageContainer">
          <video autoPlay="autoplay" loop="loop" className="loginImage">
            <source
              src="https://facimexmediamanager.prod.ingecloud.com/MediaFiles/Files/2019/11_27/0/0/17/4480.mp4"
              type="video/mp4"
            />
          </video>
        </div>
        <div className="col-md-4 col-sm-8 col-xs-12  loginCardContainer">
          <CardGroup className="loginCardGroup">
            {this.renderLoginCard(disabled)}
          </CardGroup>
        </div>
      </div>
    );
  }

  renderErrorCard = () => {
    const error = this.state.error;
    return (
      error &&
      ErrorToast.notifyError(
        error.errorMessage || I18n.t("ERRORS.ERROR"),
        error.errorCode
      )
    );
  };

  renderLoginCard = (disabled) => {
    return (
      <Card className="p-4 loginCard">
        <img
          className={"logo"}
          src={require('../../../assets/Logo_Facimex.png')}
          style={{ marginTop: 60, marginBottom: 60, width: '70%'}}
        ></img>
        <CardBody className="loginCardBody">
          <Form onSubmit={this.onLogin} id="login-form" disabled={disabled}>
            <h2
              style={{
                textAlign: "center",
                color: colors.lightBlue
              }}
            >
              {I18n.t("LOGIN.TITLE")}
            </h2>
            <p className="text-muted" style={{ marginTop: 80 }}>
              {I18n.t("LOGIN.LOGIN")}
            </p>
            {this.renderEmailInput()}
            {this.renderPassInput()}
            <Row>
              <Col xs="6">{this.renderLoginButton(disabled)}</Col>
            </Row>
            <Row className="justify-content-center">
              <Col style={{ marginTop: 50}}>
                {Spinner.render(this.state.loading)}
              </Col>
            </Row> 
          </Form>

          <Row>
            <Col xs="12" m="12" className="text-center">
              <ToastContainer />
              <div>{this.renderErrorCard()}</div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    );
  };

  renderEmailInput = () => {
    return (
      <InputGroup className="mb-3">
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <i className="icon-user"></i>
          </InputGroupText>
        </InputGroupAddon>
        <Input
          type="text"
          maxLength={Constants.SHORT_INPUT_MAX_LEN}
          placeholder={I18n.t("FIELDS.EMAIL")}
          onChange={(event) => {
            this.setState({
              email: event.target.value,
              error: false,
              message: false,
            });
          }}
        />
      </InputGroup>
    );
  };

  renderPassInput = () => {
    return (
      <InputGroup className="mb-4">
        <InputGroupAddon addonType="prepend">
          <InputGroupText>
            <i className="icon-lock"></i>
          </InputGroupText>
        </InputGroupAddon>
        <Input
          type="password"
          placeholder={I18n.t("FIELDS.PASS")}
          maxLength={Constants.SHORT_INPUT_MAX_LEN}
          autoComplete="on"
          onChange={(event) => {
            this.setState({
              password: event.target.value,
              error: false,
              message: false,
            });
          }}
        />
      </InputGroup>
    );
  };

  renderForgotButton = () => {
    return (
      <Button
        color="link"
        className="px-0"
        style={{ paddingTop: "0px" }}
        onClick={this.toSendRecoveryEmailPage}
      >
        {I18n.t("LOGIN.FORGOT_PASSWORD")}
      </Button>
    );
  };

  renderLoginButton = (disabled) => {
    return (
      <Button
        className="px-4"
        type="submit"
        form="login-form"
        disabled={disabled}
        style={{ backgroundColor: colors.blue, color: "white" }}
      >
        {I18n.t("LOGIN.BUTTON")}
      </Button>
    );
  };
}

export default withRouter(Login);
